import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function HeroIntro() {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    // Desmontar el componente después de que termine la animación
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2100); // 1.8s de animación + 0.3s de delay
    return () => clearTimeout(timer);
  }, []);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-156">
      {isVisible && <motion.div className="fixed inset-0 z-[100] pointer-events-none overflow-hidden" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-157">
          {/* Fondo negro sólido que se va "cortando" para revelar la página */}
          <motion.div className="absolute inset-0 bg-[#0A0A0A]" initial={{
        clipPath: 'inset(0 0 0 0%)'
      }} animate={{
        clipPath: 'inset(0 0 0 100%)'
      }} transition={{
        duration: 1.8,
        ease: 'easeInOut',
        delay: 0.3
      }} data-id="element-158" />

          {/* Contenedor del rayo de luz y la máquina - se mueve sincronizado con el corte del fondo */}
          <motion.div className="absolute top-0 bottom-0 w-[2px] flex items-center" initial={{
        left: '-5%'
      }} animate={{
        left: '105%'
      }} transition={{
        duration: 1.8,
        ease: 'easeInOut',
        delay: 0.3
      }} data-id="element-159">
            {/* El rayo de luz turquesa perlado intenso */}
            <div className="absolute inset-0 bg-[#B0FFFF]" style={{
          boxShadow: '0 0 20px 5px #00E5FF, 0 0 50px 15px #00FFD5, 0 0 100px 30px #00E5FF, 0 0 150px 50px rgba(0, 229, 255, 0.4)'
        }} data-id="element-160" />

            {/* La máquina de cortar pelo (diseñada con CSS) */}
            <div className="absolute right-0 mr-[2px] w-[140px] h-[56px] bg-[#0f0f0f] rounded-l-2xl rounded-r-md border border-gray-800 flex items-center shadow-2xl z-10" data-id="element-161">
              {/* Cable */}
              <div className="absolute -left-16 top-1/2 -translate-y-1/2 w-16 h-[3px] bg-[#0f0f0f] rounded-l-full shadow-sm" data-id="element-162"></div>

              {/* Detalles del cuerpo de la máquina */}
              <div className="w-full h-full relative flex items-center" data-id="element-163">
                {/* Luz indicadora de encendido (Turquesa) */}
                <div className="absolute left-6 w-3 h-3 rounded-full bg-[#00E5FF] shadow-[0_0_15px_#00E5FF] animate-pulse" data-id="element-164"></div>

                {/* Líneas de agarre */}
                <div className="absolute left-14 flex gap-1.5" data-id="element-165">
                  <div className="w-1 h-8 bg-gray-800 rounded-full" data-id="element-166"></div>
                  <div className="w-1 h-8 bg-gray-800 rounded-full" data-id="element-167"></div>
                  <div className="w-1 h-8 bg-gray-800 rounded-full" data-id="element-168"></div>
                </div>

                {/* Cuchilla (Blade) */}
                <div className="absolute right-0 w-[14px] h-[40px] bg-gray-300 rounded-r-md flex flex-col justify-between py-1 border-l border-gray-600" data-id="element-169">
                  <div className="w-full h-[2px] bg-gray-500" data-id="element-170"></div>
                  <div className="w-full h-[2px] bg-gray-500" data-id="element-171"></div>
                  <div className="w-full h-[2px] bg-gray-500" data-id="element-172"></div>
                  <div className="w-full h-[2px] bg-gray-500" data-id="element-173"></div>
                  <div className="w-full h-[2px] bg-gray-500" data-id="element-174"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}